import { useEffect } from "react";

import { useUser } from "../hooks/useUser";
import { reportError } from "./reportError";

export const initIntercom = (id: number, fullname: string, email?: string) => {
  const scriptWithObject = document.createElement("script");
  const objectHtml = `
    window.intercomSettings = {
      api_base: "https://api-iam.intercom.io",
      app_id: "pp49echb",
      user_id: "${id}",
      name: "${fullname}", // Full name
      ${email ? `email: "${email}",` : ""} // Email address if exist
      hide_default_launcher: true,
    };
  `;
  scriptWithObject.innerHTML = objectHtml;
  document.body.appendChild(scriptWithObject);

  const scriptWithFunction = document.createElement("script");
  const functionHtml = `
    // We pre-filled your app ID in the widget URL: 'https://widget.intercom.io/widget/pp49echb'
    (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/pp49echb';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
  `;
  scriptWithFunction.innerHTML = functionHtml;
  document.body.appendChild(scriptWithFunction);
};

// eslint-disable-next-line @typescript-eslint/ban-types
declare let Intercom: Function | null;

const intercomUpdate = (hide: boolean) => {
  try {
    Intercom?.("update", {
      hide_default_launcher: hide,
    });
  } catch (e) {
    reportError('intercom.ts - useIntercom.Intercom("update")', `Intercom ${hide ? "Hide" : "Show"} Error`, e as Error);
  }
};

let timeout: NodeJS.Timeout;

export const useIntercom = () => {
  const { isActivated } = useUser();

  useEffect(() => {
    if (isActivated) {
      timeout = setTimeout(() => {
        intercomUpdate(false);
      }, 3000);
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [isActivated]);

  useEffect(
    () => () => {
      clearTimeout(timeout);
      intercomUpdate(true);
    },
    []
  );
};
